"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlCartesian2dUpdateArgProvider = void 0;
const cartesian2d_update_arg_1 = require("./cartesian2d-update-arg");
/**
 * @public
 * WebGL implementation of {@link ICartesian2dUpdateArgProvider}.
 */
class GlCartesian2dUpdateArgProvider {
    constructor() {
        this.updateArg = new cartesian2d_update_arg_1.Cartesian2dUpdateArg(Float32Array);
    }
    getUpdateArg(plot, canvasDims) {
        this.updateArg.update(plot, canvasDims);
        this.updateArg.drawTransforms.update(this.updateArg.transformedDataRange, plot.plotDimensionsOBL.clipSpaceArea.wholeRange, plot.plotDimensionsOBL.clipSpaceArea.interactiveRange);
        return this.updateArg;
    }
}
exports.GlCartesian2dUpdateArgProvider = GlCartesian2dUpdateArgProvider;
//# sourceMappingURL=gl-cartesian2d-update-arg-provider.js.map